import { useState } from 'react'
import DefaultModal from '../../Utils/DefaultModal'
import { Alert, TextField, Box } from '@mui/material'
import ColorButton from '../../Buttons/ColorButton'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'
import MegaAutoComplete from '../../Utils/megautocomplete'
import IntegerOnly from '../../Utils/IntegerOnly'


const SelectBank = ({ filial, data, handleClose, submit }) => {
    const [bank, setBank] = useState(data?.bank || '')
    return (
        <DefaultModal
            open={true}
            handleClose={handleClose}
            title='Banco'
            content={
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem' }}>
                        <MegaAutoComplete
                            fullWidth={true}
                            value={bank}
                            initializeOptions={bank ? [bank] : null}
                            onChange={(value) => setBank(value)}
                            noOptionsText={'Digite para procurar um banco'}
                            timeoutUrl={`/novopedido/bancos/${filial?.id || ''}/`}
                            timeoutParam='label'
                            label='Banco'
                            sx={{ maxWidth: '10rem' }}
                        />
                    </Box>
                </Box>
            }
            action={
                <>
                    {<ColorButton
                        disabled={(bank === '')}
                        onClick={() => submit(bank)}
                    >Salvar</ColorButton>}
                </>
            }

        />
    )
}

export default SelectBank